import type { BankTransferView } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatCalendarDate } from '@/shared/lib';
export const OrderBankTransferRows = ({
  transfer,
}: {
  readonly transfer: BankTransferView;
}): ReactElement => {
  const date = (value: string | null) => (value ? value.slice(5, 10).replace('-', '/') : '확인 중');
  const status =
    transfer.status === 'READY'
      ? `입금 대기 · ~${date(transfer.dueAt)}`
      : transfer.status === 'DONE'
        ? `입금 확인 ${date(transfer.depositedOn)}`
        : transfer.status === 'REFUND_PENDING'
          ? '환불 대기'
          : transfer.status === 'CANCELED'
            ? `환불 완료 ${date(transfer.refundedOn)}`
            : transfer.status === 'EXPIRED'
              ? '입금 기한 만료'
              : '계좌이체 취소';
  return (
    <>
      <div className="flex gap-4 py-3">
        <dt className="w-24 shrink-0 text-muted-foreground">결제 상태</dt>
        <dd>{status}</dd>
      </div>
      <div className="flex gap-4 py-3">
        <dt className="w-24 shrink-0 text-muted-foreground">입금 계좌</dt>
        <dd>
          {transfer.bank.bank} {transfer.bank.account} {transfer.bank.holder}
        </dd>
      </div>
      <div className="flex gap-4 py-3">
        <dt className="w-24 shrink-0 text-muted-foreground">입금자명</dt>
        <dd>{transfer.depositorName}</dd>
      </div>
      <div className="flex gap-4 py-3">
        <dt className="w-24 shrink-0 text-muted-foreground">입금 기한</dt>
        <dd>{formatCalendarDate(transfer.dueAt.slice(0, 10))}</dd>
      </div>
      {transfer.refundAccount ? (
        <div className="flex gap-4 py-3">
          <dt className="w-24 shrink-0 text-muted-foreground">환불 계좌</dt>
          <dd>
            {transfer.refundAccount.bank}{' '}
            {'*'.repeat(Math.max(4, transfer.refundAccount.account.length - 4))}
            {transfer.refundAccount.account.slice(-4)} {transfer.refundAccount.holder}
          </dd>
        </div>
      ) : null}
    </>
  );
};
